import cx from 'classnames'
import style from './Headline.module.scss'
import commonStyle from '../Article.module.scss'


export const Headline = ({ headline }: { headline: string }) => {
    return (
      <div className={cx(commonStyle.article__content, style.headline)}>
        <h1 dangerouslySetInnerHTML={{ __html:headline}}>
          
        </h1>
      </div>
    );
  };